// extracted by mini-css-extract-plugin
export default {"container":"SuccessfulAddedVacination_container__jd4gK","text1":"SuccessfulAddedVacination_text1__zgyNV"};